/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * preprod env object for ADB2C values
 */
const adb2cEnvValues = {
    tenantId: "43effe87-26d9-496a-934b-1875486ac4cf",
    // tenantId: "de3ee5c1-5644-4113-922d-e8336569a462",
    loginDomain: "login.preprod.onepassport.onefc.com",
    // loginDomain: "login.onepassport.onefc.com",
    policyNames: {
        signUpSignIn: "B2C_1A_PreProd_SignUpSignIn_OneSuiZklogin",
        forgotPassword: "B2C_1A_PreProd_PasswordReset_OneTest",
        // signUpSignIn: "B2C_1A_PreProd_SignUpSignIn_OneApp",
        // forgotPassword: "B2C_1A_PreProd_PasswordReset_OneApp",
        // signUpSignIn: "B2C_1A_PreProd_SignUpSignIn_OneSuiZklogin",
        // signUpSignIn: "B2C_1A_Prod_SignUpSignIn_OneSuiZklogin",
        // forgotPassword: "B2C_1A_PreProd_PasswordReset_OesSamsungApp",
        // forgotPassword: "B2C_1A_Prod_PasswordReset_OneSuiZklogin",
        editProfile: "B2C_1A_PreProd_ProfileEdit"
    },
    msalConfig: {
        clientId: 'e231154e-6059-4c72-8fac-1c00939e8a44'
        // clientId: '61531b0c-3bdb-4fb0-bde5-56510fa4eaed'
    }
};

/**
 * prod env object for ADB2C values
 */
// const adb2cEnvValues = {
//     tenantId: "de3ee5c1-5644-4113-922d-e8336569a462",
//     loginDomain: "login.onepassport.onefc.com",
//     policyNames: {
//         signUpSignIn: "B2C_1A_Prod_SignUpSignIn_OesFantasy",
//         forgotPassword: "B2C_1A_Prod_PasswordReset_OesFantasy",
//         editProfile: "B2C_1A_Prod_ProfileEdit"
//     },
//     msalConfig: {
//         clientId: '4db7fafe-2459-423b-b36c-096a4538e14f'
//     }
// };

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
 export const b2cPolicies = {
    names: {
        signUpSignIn: adb2cEnvValues.policyNames.signUpSignIn,
        forgotPassword: adb2cEnvValues.policyNames.forgotPassword,
        editProfile: adb2cEnvValues.policyNames.editProfile
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${adb2cEnvValues.loginDomain}/${adb2cEnvValues.tenantId}/${adb2cEnvValues.policyNames.signUpSignIn}`
        },
        forgotPassword: {
            authority: `https://${adb2cEnvValues.loginDomain}/${adb2cEnvValues.tenantId}/${adb2cEnvValues.policyNames.forgotPassword}`
        },
        editProfile: {
            authority: `https://${adb2cEnvValues.loginDomain}/${adb2cEnvValues.tenantId}/${adb2cEnvValues.policyNames.editProfile}`
        }
    },
    authorityDomain: adb2cEnvValues.loginDomain
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: adb2cEnvValues.msalConfig.clientId, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Use a sign-up/sign-in user-flow as a default authority
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: "/", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
 export const protectedResources = {
    scopes: []
    // scopes: ["https://login.preprod.onepassport.onefc.com/907228b3-46ad-4f87-b04c-41b063a8427e/demo.read"]
    // scopes: ["https://login.preprod.onepassport.onefc.com/f7b4c10f-1d57-478a-a307-8f5bbdda3e4c/demo.read"]
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...protectedResources.scopes]
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
const silentRequest = {
  scopes: ["openid", "profile"],
  loginHint: "example@domain.net"
};

// Add scopes here for access token to be used at Microsoft Graph API endpoints.
const tokenRequest = {
    scopes: []
};
